export const minPortraitBreakpoint = '900px';
// Container queries scoped to the player frame (see playerContainerName below).
// Layout depends on the player's own dimensions so Storybook stories that render the
// player at fixed sizes (e.g. 407x770) get the correct portrait/landscape layout
// regardless of the browser viewport orientation.
export const playerContainerName = 'player';
export const mixerPortraitContainerQuery = `${playerContainerName} ((orientation: portrait) or (min-height: ${minPortraitBreakpoint}))`;
export const mixerLandscapeContainerQuery = `${playerContainerName} ((orientation: landscape) and (max-height: ${minPortraitBreakpoint}))`;
